import React, { useEffect, useState } from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import ContainerApAbierto from "./ContainerApAbierto";
import { urlConsultarDuplicidad, urlEliminarApAbierto, urlPdfApAbierto, urlProcesoApAbierto, urlRecuperarCarritoAccP } from "../../constants/urls";
import { apiPost2 } from "../../api";
import { empresa, EquiRamos } from "../../constants";
import Valores from "./Valores";
import { useDispatch, useSelector } from "react-redux";
import { isDuplicateHogar } from "../../redux/actions/ACarritoProductos";
import NumberFormat from "react-number-format";
import EmisionRetroactiva from "../CotizacionPymes/EmisionRetroactiva";

const ComponentApAbiertoResumen = (props) => {

    const [carritoActual, setCarritoActual] = useState(null)
    const [totales, setTotales] = useState(null)
    const [productos, setProductos] = useState([])
    const [loading, setLoading] = useState(false)
    const [urlPdf, setUrlPdf] = useState(null)
    const [duplicada, setDuplicada] = useState(false)
    const [tipoFacturacion, setTipoFacturacion] = useState(null)
    const [tituloPrimaNeta, setTituloPrimaNeta] = useState(null);
    const [tituloPrimaTotal, setTituloPrimaTotal] = useState(null);

    const [ramfecFuturo, setRamfecFuturo] = useState(null)
    const [ramfecRetroactividad, setRamfecRetroactividad] = useState(null)
    const [requiereEmision, setRequiereEmision] = useState(false)
    const [vigenciaRetroactiva, setVigenciaRetroactiva] = useState(new Date())
    const [errorVigenciaRetroactiva, setErrorVigenciaRetroactiva] = useState(false)
    const [bloqueoPorRiesgo, setBloqueoPorRiesgo] = useState(false)

    useEffect(() => {
        window.scrollTo(0, 0);

        generarResumen()
    }, [])

    const queryParams = new URLSearchParams(props.location.search);
    const idCarritoParam = queryParams.get("id");
    const dispatch = useDispatch()

    const checkIsDuplicate = (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity))
    const duplicity = useSelector((state) => state.datosDuplicidadPolizas)

    const descargarPdf = async () => {
        var url = `${urlPdfApAbierto}`;
        setLoading(true)

        var body = {
            "empresa": "AIGMETROPOLITANA",
            "idCarrito": idCarritoParam
        }
        try {
            const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
            const json = await response.json()
            if (json.transaccion) {

                setUrlPdf(json.url)

            }
            setLoading(false)

        } catch (error) {
            setLoading(false)

        }
    }


    /**
  * recupera la información del carrito
  */
    const generarResumen = async () => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiPost2(urlProcesoApAbierto, {
                "empresa": empresa,
                "descripcionSeguro": props.datosCotizador.descripcionSeguro,
                "plataforma": 'WEB',
                "idCarrito": idCarritoParam,
                "pasoCarrito": "resumen"
            })
            if (resultado.transaccion) {

                descargarPdf()

                recuperarCarrito()
            }


        }
        setLoading(false)


    }


    /**
    * recupera la información del carrito
    */
    const recuperarCarrito = async () => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiPost2(urlRecuperarCarritoAccP, {
                empresa: empresa,
                idCarrito: idCarritoParam
            })

            if (resultado.transaccion) {
                setCarritoActual(resultado)
                setTotales(resultado.valorTotal)
                if (resultado.carProductos.length == 0) {
                    props.history.push({
                        pathname: props.datosCotizador.urlRegresar,
                        search: `?id=${idCarritoParam}`, //agregar parametros de la url,
                    });
                } else {
                    setProductos(resultado.carProductos)
                    setTipoFacturacion(resultado.facturacion ? resultado.facturacion.label : '')

                    if (resultado.carDescripcionSeguro == 'AP Segmentos Especiales') {
                        setTituloPrimaNeta('Prima Neta por período')
                        setTituloPrimaTotal('Prima Total por período')
                    }

                    if (resultado.carDescripcionSeguro == 'ACCIDENTES PERSONALES ABIERTO') {


                        setTituloPrimaNeta('Prima Neta ' + resultado.facturacion.label)
                        setTituloPrimaTotal('Prima Total ' + resultado.facturacion.label)
                    }

                }


            }


        }
        setLoading(false)


    }

    const eliminarCategoria = async (codigo) => {

        setLoading(true)


        if (idCarritoParam) {
            const resultado = await apiPost2(urlEliminarApAbierto, {
                empresa: empresa,
                idCarrito: idCarritoParam,
                codigo: codigo,
            })

            if (resultado.transaccion) {
                recuperarCarrito()

            }


        }
        setLoading(false)


    }

    return (
        <ContainerApAbierto
            paso={'resumen'}
            titulo={props.datosCotizador.titulo}
        >

            <main class="cr-app bg-light">
                <div class="cr-content container-fluid">
                    <div className="container-body-spaces">

                        <LoadingScreen
                            loading={
                                loading
                            }

                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >

                            <Row>
                                <Col
                                    lg={8}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="detalle-cotizacion-box"
                                >
                                    <Card>
                                        <CardBody>
                                            {carritoActual &&
                                                <div>
                                                    <Button
                                                        className="btn btn-purple"
                                                        onClick={() => {
                                                            props.history.push({
                                                                pathname: props.datosCotizador.urlRegresar,
                                                                search: `?id=${idCarritoParam}`, //agregar parametros de la url,
                                                            });
                                                        }}
                                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                                    >
                                                        <i className="fa fa-plus-circle" aria-hidden="true" /> AGREGAR CATEGORÍA
                                                    </Button>
                                                    <h4>Resumen</h4>
                                                    <hr></hr>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>RUC:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosContratanteEmpresa.cliIdentificacion}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>Nombre de la empresa:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosContratanteEmpresa.cliRazonSocial}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>CI del solicitante:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosContratantePersona.cliIdentificacion}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>Nombre del solicitante:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosContratantePersona.nombreCompleto}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>Provincia:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosUbicacion.provincia.label}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>Ciudad:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosUbicacion.ciudad.label}</p></Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm={6} md={6}><p>Dirección:</p></Col>
                                                        <Col sm={6} md={6}><p>{carritoActual.datosUbicacion.direccion}</p></Col>
                                                    </Row>

                                                    <hr></hr>
                                                    {productos.map((producto, i) => {


                                                        var tituloPrimaAnualPorPersona = ''
                                                        var tituloPrimaAnualPorPoliza = ''
                                                        var valuePrimaAnualPorPersona = 0
                                                        var valuePrimaAnualPorPoliza = 0



                                                        if (tipoFacturacion === 'Anual') {
                                                            tituloPrimaAnualPorPersona = 'Prima Neta Anual por Persona:'
                                                            valuePrimaAnualPorPersona = parseFloat(producto.datosAp.primaNetaPorPersonaConAsistencia)

                                                            tituloPrimaAnualPorPoliza = 'Prima Neta Anual por Póliza:'
                                                            valuePrimaAnualPorPoliza = parseFloat(producto.datosAp.primaNetaTotalConAsistencias)

                                                        } else if (tipoFacturacion === 'Mensual') {
                                                            tituloPrimaAnualPorPersona = 'Prima Neta Mensual por Persona:'
                                                            valuePrimaAnualPorPersona = parseFloat(producto.datosAp.primaNetaPorPersonaConAsistenciaMensual)

                                                            tituloPrimaAnualPorPoliza = 'Prima Neta Mensual por Póliza:'
                                                            valuePrimaAnualPorPoliza = parseFloat(producto.datosAp.primaNetaTotalConAsistenciasMensual)

                                                        } else if (tipoFacturacion === 'Por Periodo') {
                                                            tituloPrimaAnualPorPersona = 'Prima Neta Por Período por Persona:'
                                                            valuePrimaAnualPorPersona = parseFloat(producto.datosAp.primaNetaPorPersonaConAsistencia)

                                                            tituloPrimaAnualPorPoliza = 'Prima Neta Por Período por Póliza:'
                                                            valuePrimaAnualPorPoliza = parseFloat(producto.datosAp.primaNetaTotalConAsistencias)
                                                        } else if (tipoFacturacion === '') {
                                                            tituloPrimaAnualPorPersona = 'Prima Neta por Persona:'
                                                            valuePrimaAnualPorPersona = parseFloat(producto.datosAp.primaNetaPorPersonaConAsistenciaMensual)

                                                            tituloPrimaAnualPorPoliza = 'Prima Neta por Póliza:'
                                                            valuePrimaAnualPorPoliza = parseFloat(producto.datosAp.primaNetaTotalConAsistenciasMensual)
                                                        }


                                                        return (
                                                            <div>
                                                                <Row>
                                                                    <div className="div-align-rigth">
                                                                        <Button className="btn btn-detail-gray" onClick={() => {
                                                                            props.history.push({
                                                                                pathname: props.datosCotizador.urlRegresar,
                                                                                search: `?id=${idCarritoParam}&categoria=${producto.codigo}`, //agregar parametros de la url,
                                                                            });
                                                                        }}>
                                                                            <i className="fa fa-pencil-square-o" aria-hidden="true" />{" "}
                                                                            EDITAR
                                                                        </Button>
                                                                        &nbsp;&nbsp;
                                                                        <Button
                                                                            className="btn btn-detail-white"
                                                                            onClick={() => {
                                                                                eliminarCategoria(producto.codigo)
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-trash-o" aria-hidden="true" /> ELIMINAR
                                                                        </Button>
                                                                    </div>
                                                                </Row>
                                                                <h4>{"Opción: " + (i + 1)}</h4>

                                                                <Row>
                                                                    <Col sm={6} md={6}><p>Categoría:</p></Col>
                                                                    <Col sm={6} md={6}><p style={{ color: '#AF006E', }}>{producto.datosAp.actividad.label}</p></Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6} md={6}><p>Nro. Empleados:</p></Col>
                                                                    <Col sm={6} md={6}>
                                                                        <NumberFormat
                                                                            value={parseFloat(producto.datosAp.numeroPersonas)}
                                                                            className="foo"
                                                                            displayType={'text'}
                                                                            thousandSeparator={'.'}
                                                                            decimalSeparator={','}
                                                                            decimalScale={0}
                                                                            fixedDecimalScale={0}
                                                                            prefix={''}
                                                                            renderText={(value, props) => <div
                                                                                {...props}> <p style={{ color: '#AF006E', }}>
                                                                                    {value}
                                                                                </p>
                                                                            </div>
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6} md={6}><p>Muerte accidental:</p></Col>
                                                                    <Col sm={6} md={6}>

                                                                        <NumberFormat
                                                                            value={parseFloat(producto.datosAp.valorMuerteAccidental)}
                                                                            className="foo"
                                                                            displayType={'text'}
                                                                            thousandSeparator={'.'}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={2}
                                                                            decimalSeparator={','}
                                                                            prefix={'$'}
                                                                            renderText={(value, props) => <div
                                                                                {...props}> <p style={{ color: '#AF006E', }}>
                                                                                    {value}
                                                                                </p>
                                                                            </div>
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6} md={6}><p>{tituloPrimaAnualPorPersona}</p></Col>
                                                                    <Col sm={6} md={6}>

                                                                        <NumberFormat
                                                                            value={valuePrimaAnualPorPersona}
                                                                            className="foo"
                                                                            displayType={'text'}
                                                                            thousandSeparator={'.'}
                                                                            decimalSeparator={','}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={2}
                                                                            prefix={'$'}
                                                                            renderText={(value, props) => <div
                                                                                {...props}> <p style={{ color: '#AF006E', }}>
                                                                                    {value}
                                                                                </p>
                                                                            </div>
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6} md={6}><p>{tituloPrimaAnualPorPoliza}</p></Col>
                                                                    <Col sm={6} md={6}>

                                                                        <NumberFormat
                                                                            value={valuePrimaAnualPorPoliza}
                                                                            className="foo"
                                                                            displayType={'text'}
                                                                            thousandSeparator={'.'}
                                                                            decimalSeparator={','}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={2}
                                                                            prefix={'$'}
                                                                            renderText={(value, props) => <div
                                                                                {...props}> <p style={{ color: '#AF006E', }}>
                                                                                    {value}
                                                                                </p>
                                                                            </div>
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Row>

                                                                <hr></hr>

                                                            </div>

                                                        )


                                                    })}





                                                </div>
                                            }

                                            <Row>
                                                <Col md={6} sm={6} lg={6}></Col>
                                                <Col md={6} sm={6} lg={6}></Col>
                                            </Row>
                                        </CardBody>
                                    </Card>


                                    <EmisionRetroactiva
                                        ramo={props.datosCotizador.ramo}
                                        vigenciaRetroactiva={vigenciaRetroactiva}
                                        mensaje={'¿Se requiere la emisión con una vigencia retroactiva o futura? Por favor seleccionar únicamente en caso de necesitarlo'}
                                        setVigenciaRetroactiva={(valor) => { setVigenciaRetroactiva(valor) }}
                                        requiereEmision={requiereEmision}
                                        setRequiereEmision={(valor) => { setRequiereEmision(valor) }}
                                        setLoading={(valor) => { setLoading(valor) }}
                                        ramfecFuturo={ramfecFuturo}
                                        ramfecRetroactividad={ramfecRetroactividad}
                                        setRamfecFuturo={(valor) => { setRamfecFuturo(valor) }}
                                        setRamfecRetroactividad={(valor) => { setRamfecRetroactividad(valor) }}
                                        errorVigenciaRetroactiva={errorVigenciaRetroactiva}
                                        setErrorVigenciaRetroactiva={(valor) => { setErrorVigenciaRetroactiva(valor) }}
                                        bloqueoPorRiesgo={bloqueoPorRiesgo}
                                        setBloqueoPorRiesgo={(value) => {
                                            setBloqueoPorRiesgo(value)
                                        }}
                                    />



                                </Col>

                                <Col
                                    lg={4}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="detalle-cotizacion-box"
                                >

                                    {totales &&
                                        <Valores
                                            totales={totales}
                                            paso={'resumen'}
                                            loading={loading}
                                            setLoading={(valor) => { setLoading(valor) }}
                                            idCarrito={idCarritoParam}
                                            urlPdf={urlPdf}
                                            history={props.history}
                                            duplicada={duplicada}
                                            onClickResumen={async () => {

                                                const checkDuplicidadObj = {
                                                    empresa: "AIGMETROPOLITANA",
                                                    plataforma: 'WEB',
                                                    identificacion: carritoActual.datosContratanteEmpresa.cliIdentificacion,
                                                    ramo: EquiRamos.ap,
                                                };
                                                const url = urlConsultarDuplicidad
                                                const response = await fetch(url, { body: JSON.stringify(checkDuplicidadObj), method: 'POST' })
                                                const json = await response.json()
                                                if (json.tienePolizaVigente == true) {
                                                    setDuplicada(true)


                                                } else {
                                                    setDuplicada(false)
                                                    props.history.push({
                                                        pathname: "/cotizacion-carga-vidas",
                                                        search: `?id=${idCarritoParam}`, //agregar parametros de la url,
                                                    });
                                                }

                                            }}
                                            tituloPrimaNeta={tituloPrimaNeta}
                                            tituloPrimaTotal={tituloPrimaTotal}
                                            requiereEmision={requiereEmision}
                                            vigenciaRetroactiva={vigenciaRetroactiva}
                                            errorVigenciaRetroactiva={errorVigenciaRetroactiva || bloqueoPorRiesgo}
                                        />
                                    }




                                </Col>
                            </Row>






                        </LoadingScreen>



                    </div>
                </div>
            </main>

        </ContainerApAbierto>

    );
};
export default ComponentApAbiertoResumen;
